// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"54773bdc","771":"12c2cc0a","776":"0b6d7049","957":"b111fede"}[chunkId] + ".chunk.js";
};